<template>
	<div class="Box">
		<el-card class="box-card">
			<el-form :model="queryParams" size="medium" label-width="100px" class="mt35">
				<el-row :gutter="35">
					<el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
						<el-form-item label="书籍ID：">
							<el-input v-model="queryParams.book_id" @change="search" @clear="search" placeholder="请输入书籍ID" clearable></el-input>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
						<el-form-item label="书籍名称：">
							<el-input v-model="queryParams.book_name" @change="search" @clear="search" placeholder="请输入书籍名称" clearable></el-input>
						</el-form-item>
					</el-col>
					
					<el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
						<el-form-item label="版权名称">
							
							<el-select v-model="queryParams.source" style="width: 100%"  @change="search" @clear="search" placeholder="请选择版权名称" clearable>
								<el-option v-for="dict in appidList" :key="dict.id" :label="dict.name"
										:value="dict.id"/>
							</el-select>
						</el-form-item>
					</el-col>
					

					<el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
						<el-form-item label="日期">
							<el-date-picker
								style="width: 100%"
								v-model="queryParams.date"
								value-format="yyyy-MM-dd"
								type="daterange"
								align="right"
								unlink-panels
								start-placeholder="开始时间"
								end-placeholder="结束时间"
								@clear="search"
								 @change="search"
							>
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="6" class="mb20">
						<el-button size="medium" type="primary" @click="search">查询</el-button>
						<el-button size="medium" @click="addNoNe">重置</el-button>
					</el-col>
				</el-row>
			</el-form>
			<div class="div_buttom">
				<el-button size="medium" type="primary" icon="el-icon-plus" @click="addList">添加导出</el-button> 
<!--				<el-button size="medium" type="primary" icon="el-icon-search" @click="addSearch">打开搜索</el-button>-->
			</div>
			<el-table
				ref="multipleTable"
				:data="tableData"
				tooltip-effect="dark"
				style="width: 100%; text-align: center"
        size="medium"
				@sort-change="handleSelectionChange"
				border
				:header-cell-style="{ textAlign: 'center' }"
				:cell-style="{ textAlign: 'center' }"
        v-loading="loading"
			>
				<el-table-column type="selection" width="55"> </el-table-column>
				<el-table-column label="日期" prop="date" sortable="custom">
					<template slot-scope="scope">{{ scope.row.date }}</template>
				</el-table-column>
				<el-table-column label="书籍ID" width="120">
					<template slot-scope="scope">{{ scope.row.book_id }}</template>
				</el-table-column>
				<el-table-column label="书籍名称">
					<template slot-scope="scope">{{ scope.row.book_name }}</template>
				</el-table-column>
				<el-table-column label="版权名称" width="170">
					<template slot-scope="scope">{{ scope.row.source_text }}</template>
				</el-table-column>
				<el-table-column label="书币充值人数"  width="120">
					<template slot-scope="scope">{{ scope.row.normal_recharge_user }}</template>
				</el-table-column>
				<el-table-column label="书币充值金额" prop="normal_recharge_money" sortable="custom" width="130">
					<template slot-scope="scope">{{ scope.row.normal_recharge_money }}</template>
				</el-table-column>
				<el-table-column label="VIP充值人数"  width="120">
					<template slot-scope="scope">{{ scope.row.vip_recharge_user }}</template>
				</el-table-column>
				<el-table-column label="VIP充值金额"  prop="vip_recharge_money" sortable="custom" width="150">
					<template slot-scope="scope">{{ scope.row.vip_recharge_money }}</template>
				</el-table-column>
				
			
			</el-table>
			<!-- 分页组件 -->
			<pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNo" :limit.sync="queryParams.pageSize" @pagination="getOrderList" />
		</el-card>
	</div>
</template>
<script>
import { OrderApi } from '@/api/Order/index';
import { Session } from '@/utils/storage';
import { processErrors } from "@/utils/errorHandler";

export default {
	name: 'MoneyList',
	components: {},
	data() {
		return {
			SearchFlag: false,
			queryParams: {
				pageNo: 1,
				pageSize: 10,
				book_name: '',
				source: '',
				date:'',
				sort_field:'',
				sort_value:'',
			},
			edit: {
				// id: this.editList.id,
				state: '',
			},

			dialogVisible: false,
			tableData: [],
			total: 0,
			multipleSelection: [],
			editList: {},
			snapshotList: {},
      loading: false,
	  appidList:[],//版权列表
		};
	},
	mounted() {
		this.getbq()
		this.getOrderList();
	},

	methods: {
		
		getbq(){
			const api = OrderApi();
			api
				.getcopyright_select()
				.then((res) => {
					console.log(res,'版权列表')
					this.appidList = res.data
				})
		},
		search() {
			this.getOrderList();
		},
		addNoNe() {
			this.queryParams = {
				pageNo: 1,
				pageSize: 10,
				book_name: '',
				source: '',
				date:'',
				sort_field:'',
				sort_value:'',
				
			};
      this.getOrderList();
		},

		handleClose(done) {
			done();
			this.$refs['ruleForm'].resetFields();
		},
		addSearch() {
			this.SearchFlag = !this.SearchFlag;
		},
		getOrderList() {
		  this.loading = true;
			const api = OrderApi();
			api
				.getcopyright_collect(this.queryParams)
				.then((res) => {
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.total = res.data.totalCount;
					}else{
            processErrors(res);
          }
					this.loading = false;
				})
				.catch((error) => {
					console.error('Error fetching user data:', error);
					this.loading = false;
				});
		},
		handleSelectionChange({ column, prop, order }) {
			if(order)
			{
				this.queryParams.sort_field = prop
				this.queryParams.sort_value = order.slice(0, -6)
			}
			else
			{
				this.queryParams.sort_field = ''
				this.queryParams.sort_value = ''
			}
			this.getOrderList();
			console.log(column,prop,order,'90')
		},
		//修改
		handleUpdate() {},
		//删除
		handleDel() {},
		// 导出
		addList() {
      const params = {...this.queryParams};
      const urlParams = new URLSearchParams();
      // 处理其他参数
      Object.keys(params).forEach((key) => {
        if (params[key] && key !== 'pageNo' && key !== 'pageSize' && key !== 'date') {
          urlParams.append(key, params[key]);
        }
      });
      // 处理 created_at 参数
      if (params.date && Array.isArray(params.date)) {
        params.date.forEach((date) => {
          urlParams.append('date[]', date);
        });
      }
    //   // 处理 created_at 参数
    //   if (params.user_createtime && Array.isArray(params.user_createtime)) {
    //     params.user_createtime.forEach((date) => {
    //       urlParams.append('user_createtime[]', date);
    //     });
    //   } // 处理 created_at 参数
    //   if (params.finistime && Array.isArray(params.finistime)) {
    //     params.finistime.forEach((date) => {
    //       urlParams.append('finistime[]', date);
    //     });
    //   }
      let url = new URL(window.location.href);
      let token = url.searchParams.get('token');
      if (token !== null) {
        urlParams.append('token', token)
      } else if (Session.get('token')) {
        urlParams.append('token', Session.get('token'))
      }
      // 获取基础 URL
      const baseExportUrl = 'https://backend.bakaba.cn/admin/index/copyright_collect_export';
      console.log(baseExportUrl,'获取基础 URL')
      // 拼接 URL 参数
      const fullExportUrl = baseExportUrl + '?' + urlParams.toString();
      console.log(fullExportUrl,'拼接 URL 参数')
      // return false
      window.location.href = fullExportUrl;
    },
	},
};
</script>
<style lang="scss" scoped>
.Box {
	& ::v-deep el-card__body {
		padding: 0 !important;
	}
	.el-form-item__label {
		width: 100px !important;
	}
}

.el-card__body {
	padding: 0px !important;
}

.btn_left {
	margin-left: 100px;
}

.div_buttom {
	width: 100%;
	display: flex;
	margin-bottom: 20px;
}
</style>
